import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigateService } from '@app/services/navigate.service';
import { ImageModel, AlignmentOption } from 'library-explorer';
import { SlideDTO } from 'src/app/model/slideDTO.model';

@Component({
    selector: 'app-slide-image',
    templateUrl: './slide-image.component.html',
    styleUrls: ['./slide-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SlideImageComponent implements OnInit {
  @Input() public slideData: Partial<SlideDTO>;
  @Input() public preventImageDownload = false;
  @Input() public watermarkEnabled = false;

  public readonly alignments: typeof AlignmentOption = AlignmentOption;
  public image: ImageModel;

  private mediaQuery = window.matchMedia('(max-width: 768px)');

  constructor(private navigateService: NavigateService) { }

  ngOnInit(): void {
    this.initializeMediaImage(this.mediaQuery.matches);

    if (this.slideData.mobileMediaImage) {
      this.mediaQuery.addEventListener('change', (event: MediaQueryListEvent) => this.initializeMediaImage(event.matches));
    }
  }

  public openImageUrl(): void {
    const link = this.slideData.mediaImage && this.slideData.mediaImage.link;

    if (!link || !link.uri) {
      return;
    }

    this.navigateService.navigate(link.uri);
  }

  private initializeMediaImage(isPhone: boolean) {
    if (!this.slideData.mobileMediaImage) {
      this.image = this.slideData.mediaImage;
      return;
    }

    this.image = isPhone ? this.slideData.mobileMediaImage : this.slideData.mediaImage;
  }



}
